<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header content="建筑礼包配置" @back="goBack" /></span>
        </div>

        <el-table style="border:1px solid #ccc" :data="formData" border stripe>
          <el-table-column prop="start" label="等级">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.level" />
            </template>
          </el-table-column>
          <el-table-column prop="buyNum" label="价格">
            <template slot-scope="scope">
              <el-select v-model="scope.row.price" placeholder="请选择" @change="(v)=>priceChange(v,scope.$index)">
                <el-option
                  v-for="(item, index) in shopSku"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>

          <el-table-column prop="scope" label="奖励">
            <template slot-scope="scope">
              <ActReward :value="scope.row.prize" />
            </template>
          </el-table-column>

          <el-table-column>
            <template slot-scope="scope">
              <el-button v-permisaction="['config:shopPromotion:del']" type="danger" @click="del(scope.$index)">删除</el-button>
            </template>
          </el-table-column>

        </el-table>

        <div style="margin-top: 20px;text-align: center">
          <el-button v-permisaction="['config:shopPromotion:add']" type="primary" @click="add">+</el-button>
          <el-button v-permisaction="['config:shopPromotion:add']" :disabled="isOnline === 1" type="primary" @click="onSubmit">保存</el-button>
        </div>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import {
  getActivtyStageRewardCfg, updateActivtyStageRewardCfg
} from '@/api/config/activity-cfg'
import { getSku } from '@/api/config/shop-cfg'
import ActReward from '@/components/Reward/act.vue'

export default {
  name: 'RewardBuildPackEdit',
  components: { ActReward },
  data() {
    return {
      isOnline: 0,
      ucType: 0,
      rewardType: [],
      drawer: [{ visible: false }],
      shopSku: [],
      formData: [{
        level: 0,
        sku: 0,
        price: 0,
        gid: 220001,
        prize: []
      }]
    }
  },
  created() {
    this.getSkuList()
    this.aid = this.$route.query.id
    this.type = this.$route.query.type
    this.ucType = this.$route.query.uc_type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.getTables()
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    onSubmit() {
      for (const i in this.formData) {
        const val = this.formData[i]
        if (val.level <= 0) {
          this.msgError('等级不能小于0')
          return
        }

        for (const k in val.prize) {
          const p = val.prize[k]
          if (p.type === 65) {
            val.prize[k].num *= 10000
          }
        }
        this.formData[i] = val
      }

      const postData = { type: this.type, aid: this.aid, reward: this.formData }
      const data = JSON.stringify(postData)
      updateActivtyStageRewardCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleClose(done, index) {
      this.drawer[index].visible = false
    },
    getTables() {
      getActivtyStageRewardCfg({ id: this.aid }).then(res => {
        if (res.code === 200) {
          res.data.reward.forEach((item, index) => {
            console.log('reward', item)
            for (const i in item.prize) {
              const p = item.prize[i]
              if (p.type === 65) {
                res.data.reward[index].prize[i].num /= 10000
              }
            }

            this.drawer.push({ visible: false })
          })
          this.formData = res.data.reward
        } else {
          this.msgError(res.msg)
        }
      })
    },
    addReward(index) {
      this.formData[index].prize.push(
        {
          id: 0,
          num: 0,
          type: 1,
          rtype: 1,
          is_ts: 0,
          skin: 0,
          ts: 0
        }
      )
    },
    removeReward(index, i) {
      this.formData[index].prize = this.formData[index].prize.filter((item, key) => {
        return i !== key
      })
    },
    priceChange(v, index) {
      let sku = ''
      for (const i in this.shopSku) {
        const val = this.shopSku[i]
        if (val.value === v) {
          sku = val.sku
          break
        }
        this.shopSku[i].price = parseFloat(val.price)
      }

      if (sku === '') {
        this.msgError('库存匹配失败')
        return
      }

      this.formData[index].sku = sku
    },
    getSkuList() {
      getSku({ type: 3 }).then(res => {
        if (res.code === 200) {
          this.shopSku = []
          res.data.forEach((item) => {
            this.shopSku.push({ label: item.price, value: item.price, sku: item.sku })
          })
          console.log(2)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.push({
        level: 0,
        sku: this.shopSku[0].sku,
        price: this.shopSku[0].value,
        gid: 220001,
        prize: []
      })
      this.drawer.push({ visible: false })
    },
    del(i) {
      this.formData = this.formData.filter((item, index) => {
        return index !== i
      })
    }
  }
}
</script>

<style scoped>
</style>
